import { Theme } from '../types/theme';

const THEME_KEY = 'cortex-theme-preference';

export function getTheme(): Theme {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'vir') {
      return saved;
    }
  } catch (e) {
    console.error('Failed to access localStorage for theme:', e);
  }
  return 'vir'; // Default to cream (vir) theme
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (e) {
    console.error('Failed to save theme to localStorage:', e);
  }
}
